import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../../components";

const UpdateLineItemsModal = props => {
	const { lang } = global;
	const { show, onCancel, onConfirm } = props;

	return (
		<Modal
			show={show}
			onHide={onCancel}
		>
			<Modal.Header closeButton>
				<Modal.Title>{lang.t("Apply Job Updates")}</Modal.Title>
			</Modal.Header>
			<Modal.Body className="text-center">
				{lang.t(
					"Applying job updates will overwrite all line items with data from the associated jobs_",
				)}
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					className="btn btn-link"
					onClick={onCancel}
				>
					{lang.t("Cancel")}
				</button>
				<button
					type="button"
					className="btn btn-primary"
					onClick={onConfirm}
				>
					{lang.t("Confirm")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

UpdateLineItemsModal.propTypes = {
	show: PropTypes.bool,
	onCancel: PropTypes.func,
	onConfirm: PropTypes.func,
};

UpdateLineItemsModal.defaultProps = {
	show: false,
	onCancel: () => {},
	onConfirm: () => {},
};

export default UpdateLineItemsModal;
